"use strict";

(function (global) {
  /**
   * Функции отвечающие за работу с задачами и заданиями.
   * @namespace Core.customWorks
   * @since 5.5.0.2201
   */
  global.customWorks = {};
})(window.Core);

(function (global) {
  /**
   * Установить доступность кнопок на ленте для задач и заданий.
   * @since 5.5.2201
   */
  global.bindButtonsEnabling = function (textAreaSelector) {
    var buttonNames = ['Save'];
    // Флаг, указывающий необходимость осуществления блокировки кнопок не ленте
    // на основе режима доступности
    var isControlChangedBefore = false;
    $(textAreaSelector).one("keypress", function () {
      Core.cards.enableButtonsOnFormChange(buttonNames);
      if (!isControlChangedBefore) {
        Core.cards.setButtonsEnablingOnEnabledMode();
        isControlChangedBefore = true;
      }
    });
    // Установить изменение доступности при изменении списка вложений.
    var attachments = $('.ListRequisite');
    attachments.change(function () {
      Core.cards.enableButtonsOnFormChange(buttonNames);
      if (!isControlChangedBefore) {
        Core.cards.setButtonsEnablingOnEnabledMode();
        isControlChangedBefore = true;
      }
    });
    // Установить изменение состояний на основе выделения списка вложений
    attachments.on('itemChecked', function () {
      var buttons = WA.CR.toolBar.buttons.getButtonsEnabledOnAttachmentSelection();
      var selectedItems = WA.CR.objectList.getSelectedItems();
      if (selectedItems.length) {
        buttons.forEach(function (button) {
          // В зависимости от состояния ЗЗУ
          switch (WA.CR.State) {
            case WORK_STATE.RUNNING:
            case WORK_STATE.CONTROLLED:
            case WORK_STATE.CONTINUED:
              if (button.getIsEnabledOnRunning()) {
                button.enable();
              }
              break;
            case WORK_STATE.DONE:
              if (button.getIsEnabledOnDone()) {
                button.enable();
              }
              break;
            case WORK_STATE.ABORTED:
              if (button.getIsEnabledOnAborted()) {
                button.enable();
              }
              break;
          }
        });
      } else {
        buttons.forEach(function (button) {
          button.disable();
        });
      }
    });
  };

})(window.Core.customWorks)